import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  label: {
    fontSize: 14,
    marginLeft: theme.spacing(1),
  },
}));
